import React, { useState, useEffect, useRef } from "react";
import { useCountUp } from "react-countup";
import styled from "styled-components";

function isEven(value) {
  if (value % 2 == 0) return true;
  else return false;
}

const Img = styled.img`
  position: absolute;
  transform: translate3d(0, 0, 0);
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
`;

const Loading = styled.div`
  position: absolute;
  z-index: 9999;
  background: #fff;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const images = [
  require("../images/QIAcuity_One_360_2/Qia_one_360_001.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_002.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_003.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_004.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_005.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_006.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_007.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_008.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_009.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_010.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_011.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_012.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_013.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_014.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_015.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_016.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_017.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_018.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_019.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_020.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_021.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_022.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_023.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_024.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_025.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_026.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_027.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_028.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_029.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_030.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_031.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_032.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_033.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_034.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_035.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_036.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_037.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_038.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_039.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_040.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_041.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_042.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_043.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_044.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_045.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_046.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_047.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_048.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_049.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_050.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_051.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_052.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_053.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_054.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_055.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_056.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_057.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_058.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_059.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_060.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_061.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_062.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_063.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_064.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_065.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_066.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_067.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_068.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_069.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_070.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_071.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_072.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_073.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_074.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_075.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_076.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_077.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_078.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_079.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_080.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_081.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_082.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_083.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_084.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_085.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_086.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_087.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_088.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_089.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_090.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_091.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_092.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_093.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_094.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_095.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_096.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_097.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_098.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_099.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_100.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_101.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_102.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_103.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_104.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_105.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_106.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_107.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_108.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_109.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_110.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_111.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_112.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_113.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_114.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_115.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_116.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_117.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_118.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_119.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_120.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_121.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_122.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_123.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_124.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_125.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_126.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_127.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_128.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_129.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_130.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_131.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_132.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_133.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_134.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_135.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_136.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_137.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_138.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_139.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_140.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_141.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_142.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_143.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_144.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_145.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_146.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_147.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_148.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_149.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_150.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_151.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_152.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_153.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_154.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_155.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_156.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_157.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_158.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_159.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_160.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_161.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_162.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_163.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_164.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_165.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_166.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_167.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_168.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_169.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_170.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_171.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_172.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_173.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_174.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_175.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_176.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_177.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_178.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_179.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_180.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_181.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_182.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_183.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_184.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_185.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_186.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_187.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_188.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_189.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_190.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_191.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_192.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_193.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_194.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_195.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_196.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_197.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_198.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_199.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_200.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_201.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_202.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_203.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_204.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_205.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_206.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_207.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_208.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_209.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_210.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_211.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_212.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_213.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_214.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_215.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_216.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_217.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_218.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_219.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_220.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_221.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_222.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_223.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_224.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_225.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_226.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_227.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_228.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_229.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_230.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_231.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_232.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_233.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_234.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_235.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_236.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_237.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_238.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_239.jpg"),
  require("../images/QIAcuity_One_360_2/Qia_one_360_240.jpg")
];

export default ({ progress, path, active }) => {
  var frames = images.length;
  const [mounted, setMounted] = useState(false);
  const [loading, setLoading] = useState(true);
  const [end, setEnd] = useState(null);
  const [startIndex, setStartIndex] = useState(0);
  const [dragging, setDrag] = useState(null);

  const { countUp, update } = useCountUp({
    start: 0,
    end: 0,
    duration: 3,
    useEasing: false,
    onEnd: ({ reset }) => {
      setEnd(0);
      reset();
    }
  });

  const touchStart = event => {
    event.preventDefault();
    const { screenX } =
      event.type.indexOf("touch") === 0 ? event.changedTouches[0] : event;
    setDrag(screenX);
    setStartIndex(end);
    //console.log("=======> START");
  };

  const touchMove = event => {
    if (dragging !== null) {
      const { screenX } =
        event.type.indexOf("touch") === 0 ? event.changedTouches[0] : event;
      const pixelsPerDegree = 3;
      const pixelsPerImage = pixelsPerDegree * (360 / frames);
      let dx = (screenX - dragging) / pixelsPerImage;
      let index = Math.floor(dx) % frames;
      if (index < 0) {
        index = frames + index - 1;
      }
      index = (index + startIndex) % frames;
      setEnd(index);
    }
  };

  const touchEnd = event => {
    event.preventDefault();
    setDrag(null);
    //console.log("=======> END");
  };

  useEffect(() => {
    // var arrayString = "";
    // [...Array(240)].map((e, i) => {
    //   const number = i < 100 && i > 9 ? `0${i}` : i < 10 ? `00${i}` : i;
    //   var res = path.replace(/\d{3}$/, number);
    //   arrayString += `require("${`../images/${res}.jpg`}"),`;
    // });
    // console.log(arrayString);
    setMounted(true);
    document.addEventListener("mouseup", touchEnd, false);
    return () => {
      document.removeEventListener("mouseup", touchEnd, false);
    };
  }, []);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => {
        update(frames);
      }, 2000);
    }
  }, [loading]);

  const index = end !== null ? end : countUp ? parseInt(countUp) : undefined;

  if (!mounted) return null;

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        height: "auto",
        alignItems: "center",
        position: "relative"
      }}
    >
      <div
        className="image-360"
        style={{ width: "100%", position: "relative", cursor: "grab" }}
        onTouchStart={touchStart}
        onTouchMove={touchMove}
        onTouchEnd={touchEnd}
        onMouseDown={touchStart}
        onMouseUp={touchEnd}
        onMouseMove={touchMove}
      >
        <img
          src={require(`../images/${path}.jpg`)}
          width="100%"
          height="auto"
          style={{ opacity: index === 0 ? 1 : 0 }}
        />
        {images.map((img, i) => {
          return (
            <img
              src={img}
              style={{
                position: "absolute",
                left: 0,
                top: 0,
                right: 0,
                bottom: 0,
                width: "100%",
                height: "100%",
                visibility:
                  index === i || (index - 7 < i && index > i)
                    ? "visible"
                    : "hidden"
              }}
              key={img}
              onLoad={() => {
                if (i === images.length - 1) {
                  setLoading(false);
                }
              }}
            />
          );
          return (
            <Img
              src={img}
              key={img}
              style={{
                visibility:
                  index === i || (index - 7 < i && index > i)
                    ? "visible"
                    : "hidden"
              }}
              onLoad={() => {
                if (i === images.length - 1) {
                  setLoading(false);
                }
              }}
            />
          );
        })}
        {loading ? <Loading>loading...</Loading> : null}
      </div>
    </div>
  );
};
